/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import * as Core from 'app/core/models/essette-api';

@autoinject()
export class UserTwoFactorAuthentication extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.object()
    protected user: Core.User | null = null;

    @bindable.boolean()
    protected allowUserChoiceIsEnabled: boolean = false;

    @bindable()
    public readonly: boolean = false;
    public twoFactorOptIn: boolean = false;
    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        ...rest: any[]) {

        super(...rest);
    }

    ////****************** Functions ************************************************////

    protected updateOptIn() {
        this.twoFactorOptIn = this.user?.twoFactorAuthentication?.optedIn ? this.user?.twoFactorAuthentication?.optedIn : false;
    }

    ////****************** Service Calls ********************************************////
}
